export const proPetroThreeDTheme = {
  themePrimary: "#00875A",
  themeLighterAlt: "#eff6fc",
  themeLighter: "#deecf9",
  themeLight: "#c7e0f4",
  themeTertiary: "#71afe5",
  themeSecondary: "#2b88d8",
  themeDarkAlt: "#106ebe",
  themeDark: "#005a9e",
  themeDarker: "#004578",
  neutralLighterAlt: "#faf9f8",
  neutralLighter: "#f3f2f1",
  neutralLight: "#edebe9",
  neutralQuaternaryAlt: "#e1dfdd",
  neutralQuaternary: "#d0d0d0",
  neutralTertiaryAlt: "#c8c6c4",
  neutralTertiary: "#879cbf",
  neutralSecondary: "#6880aa",
  neutralSecondaryAlt: "#6880aa",
  neutralPrimaryAlt: "#4d6895",
  neutralPrimary: "#172B4D",
  neutralDark: "#233e6c",
  black: "#142d57",
  white: "#ffffff",
};
